"use client";

import * as React from "react";

import { useCarousel } from "@/components/carousel/useCarousel";
import { cn } from "@/utils/cn";

export const CarouselItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  const { orientation } = useCarousel();

  return (
    <div
      ref={ref}
      role="group"
      aria-roledescription="slide"
      className={cn(
        "min-w-0 shrink-0 grow-0 basis-full",
        orientation === "horizontal" ? "pl-16" : "pt-16",
        className
      )}
      {...props}
    />
  );
});
CarouselItem.displayName = "CarouselItem";
